import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Box, Link, Button, ArrowDown, useWindowSize } from '@miro-site/core';
import { theme as defaultTheme } from '@miro-site/design-tokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AccordionContainer = styled(Box).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    as: 'nav',
    $styles: {
      maxWidth: theme.header ? theme.header.container.maxWidth : null
    },
    $pl: theme.accordion.gutter,
    $pr: theme.accordion.gutter,
    $mx: 'auto'
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionContainer",
  componentId: "sc-q5k0q2-0"
})([""]);
var AccordionItem = styled(Box).attrs({
  as: 'li'
}).withConfig({
  displayName: "AccordionMenu__AccordionItem",
  componentId: "sc-q5k0q2-1"
})(["", ""], function (props) {
  return props.theme.normalizeStyles(props.theme.accordion.itemStyles);
});
var AccordionCategory = styled(Box).attrs(function (_ref2) {
  var $isActive = _ref2.$isActive,
      theme = _ref2.theme;
  return {
    $styles: {
      display: ['block', 'inline-block'],
      fontSize: theme.accordion.category.fontSize,
      fontWeight: theme.accordion.category.fontWeight,
      lineHeight: theme.accordion.category.lineHeight,
      color: $isActive ? defaultTheme.colors.outspoken : defaultTheme.colors.primaryWhite,
      borderBottom: '1px solid transparent',
      transition: '250ms ease',
      transitionProperty: 'color, border-color'
    }
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionCategory",
  componentId: "sc-q5k0q2-2"
})([""]);
var AccordionCategoryWrapper = styled(Box).attrs(function (_ref3) {
  var theme = _ref3.theme;
  return {
    $styles: {
      position: 'relative',
      cursor: 'pointer'
    },
    $py: theme.accordion.categoryWrapper.padding
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionCategoryWrapper",
  componentId: "sc-q5k0q2-3"
})(["@media (hover:hover){&:hover ", "{", "}}"], AccordionCategory, function (props) {
  return props.theme.normalizeStyles({
    color: defaultTheme.colors.outspoken,
    borderColor: defaultTheme.colors.outspoken
  });
});
var AccordionButton = styled(Button).attrs(function (props) {
  return {
    $styles: {
      display: 'block',
      ':focus': _objectSpread({}, props.theme.focus.outlines.withOffset)
    }
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionButton",
  componentId: "sc-q5k0q2-4"
})([""]);
var AccordionLink = styled(Link).attrs(function (props) {
  return {
    $styles: {
      display: ['block', 'inline-block'],
      ':focus': _objectSpread({}, props.theme.focus.outlines.withOffset)
    }
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionLink",
  componentId: "sc-q5k0q2-5"
})([""]);
var AccordionInnerLink = styled(Link).attrs(function (props) {
  return {
    $styles: {
      fontSize: props.theme.accordion.innerLink.fontSize,
      lineHeight: props.theme.accordion.innerLink.lineHeight,
      position: 'relative',
      ':after': {
        content: "''",
        background: 'var(--deprecated-legacy-accordion-menu-background-color)',
        position: 'absolute',
        top: -12,
        left: -15,
        right: -45,
        bottom: -12,
        borderRadius: 8,
        opacity: 0,
        transition: 'opacity 250ms ease'
      },
      ':focus': _objectSpread({}, props.theme.focus.outlines.withOffset),
      '@media (hover: hover)': {
        ':hover:after': {
          opacity: 1
        }
      }
    }
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionInnerLink",
  componentId: "sc-q5k0q2-6"
})([""]);
var AccordionSubcategoryContainer = styled(Box).attrs(function (_ref4) {
  var $isActive = _ref4.$isActive;
  return {
    $styles: {
      visibility: $isActive ? 'visible' : 'hidden',
      overflow: 'hidden',
      transition: '400ms ease',
      transitionProperty: 'height, visibility'
    }
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionSubcategoryContainer",
  componentId: "sc-q5k0q2-7"
})([""]);
var AccordionSubcategoryWrapper = styled(Box).attrs(function (_ref5) {
  var theme = _ref5.theme;
  return {
    $pl: theme.accordion.subcategoryWrapper.padding.left,
    $pb: theme.accordion.subcategoryWrapper.padding.bottom
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionSubcategoryWrapper",
  componentId: "sc-q5k0q2-8"
})([""]);
var AccordionSubcategory = styled(Box).attrs(function (_ref6) {
  var theme = _ref6.theme;
  return {
    as: 'h4',
    $styles: {
      fontSize: theme.accordion.subcategory.fontSize,
      lineHeight: theme.accordion.subcategory.lineHeight,
      fontWeight: theme.accordion.subcategory.fontWeight,
      color: theme.accordion.subcategory.color
    }
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionSubcategory",
  componentId: "sc-q5k0q2-9"
})([""]);
var AccordionInnerList = styled(Box).attrs(function (_ref7) {
  var theme = _ref7.theme,
      $isOffset = _ref7.$isOffset;
  return {
    as: 'ul',
    $mt: $isOffset ? theme.accordion.innerList.margin.top : null
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionInnerList",
  componentId: "sc-q5k0q2-10"
})([""]);
var AccordionInnerItem = styled(Box).attrs(function (_ref8) {
  var theme = _ref8.theme;
  return {
    as: 'li',
    $mt: theme.accordion.innerItem.margin.top
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionInnerItem",
  componentId: "sc-q5k0q2-11"
})(["&:first-child{margin-top:0;}"]);
var AccordionLinkDescription = styled(Box).attrs(function (_ref9) {
  var theme = _ref9.theme;
  return {
    $styles: {
      fontSize: theme.accordion.description.fontSize,
      lineHeight: theme.accordion.description.lineHeight,
      color: theme.accordion.description.color,
      opacity: theme.accordion.description.opacity
    },
    $mt: theme.accordion.description.margin.top
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionLinkDescription",
  componentId: "sc-q5k0q2-12"
})([""]);
var AccordionAdditionalLink = styled(Link).attrs(function (_ref10) {
  var theme = _ref10.theme;
  return {
    $mt: theme.accordion.additionalLink.margin.top
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionAdditionalLink",
  componentId: "sc-q5k0q2-13"
})([""]);
var AccordionIcon = styled(Box).attrs(function (_ref11) {
  var $isActive = _ref11.$isActive;
  return {
    $styles: {
      position: 'absolute',
      top: '50%',
      right: 0,
      transform: $isActive ? 'translateY(-50%) scaleY(-1)' : 'translateY(-50%) scaleY(1)',
      transition: 'transform 250ms ease'
    }
  };
}).withConfig({
  displayName: "AccordionMenu__AccordionIcon",
  componentId: "sc-q5k0q2-14"
})([""]);

var AccordionMenu = function AccordionMenu(props) {
  var categories = props.categories;

  var _useState = useState(categories.reduce(function (acc, c, i) {
    acc[i] = false;
    return acc;
  }, [])),
      expandedItems = _useState[0],
      setExpandedItems = _useState[1];

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width,
      height = _useWindowSize.height;

  var linkRefs = useRef([]);
  var containerRefs = useRef([]);
  useEffect(function () {
    containerRefs.current.forEach(function (container, i) {
      var _container$firstChild;

      if (!container) {
        return;
      }

      container.style.height = expandedItems[i] ? "".concat(((_container$firstChild = container.firstChild) === null || _container$firstChild === void 0 ? void 0 : _container$firstChild.offsetHeight) || 0, "px") : "0px";
    });
  }, [expandedItems, height, width]);
  return /*#__PURE__*/_jsx(AccordionContainer, {
    "aria-label": "Accordion menu",
    className: props.className,
    children: /*#__PURE__*/_jsx("ul", {
      children: categories.map(function (category, categoryIndex) {
        return /*#__PURE__*/_jsxs(AccordionItem, {
          children: [category.path ? /*#__PURE__*/_jsx(AccordionCategoryWrapper, {
            onClick: function onClick() {
              var link = linkRefs.current[categoryIndex];

              if (link !== null) {
                link.click();
              }
            },
            children: /*#__PURE__*/_jsx(AccordionLink, {
              ref: function ref(_ref12) {
                linkRefs.current[categoryIndex] = _ref12;
              },
              href: category.path,
              children: /*#__PURE__*/_jsx(AccordionCategory, {
                children: category.title
              })
            })
          }) : /*#__PURE__*/_jsxs(AccordionCategoryWrapper, {
            onClick: function onClick() {
              return setExpandedItems(_objectSpread(_objectSpread({}, expandedItems), {}, _defineProperty({}, categoryIndex, !expandedItems[categoryIndex])));
            },
            children: [/*#__PURE__*/_jsx(AccordionButton, {
              "aria-expanded": expandedItems[categoryIndex],
              children: /*#__PURE__*/_jsx(AccordionCategory, {
                $isActive: expandedItems[categoryIndex],
                children: category.title
              })
            }), /*#__PURE__*/_jsx(AccordionIcon, {
              $isActive: expandedItems[categoryIndex],
              "aria-hidden": true,
              children: /*#__PURE__*/_jsx(ArrowDown, {})
            })]
          }), category.groups && /*#__PURE__*/_jsx(AccordionSubcategoryContainer, {
            ref: function ref(_ref13) {
              containerRefs.current[categoryIndex] = _ref13;
            },
            $isActive: expandedItems[categoryIndex],
            "aria-hidden": !expandedItems[categoryIndex],
            children: /*#__PURE__*/_jsx("div", {
              children: category.groups.map(function (subcategory, subcategoryIndex) {
                return /*#__PURE__*/_jsxs(AccordionSubcategoryWrapper, {
                  children: [subcategory.title && /*#__PURE__*/_jsx(AccordionSubcategory, {
                    children: subcategory.title
                  }), /*#__PURE__*/_jsx(AccordionInnerList, {
                    $isOffset: !!subcategory.title,
                    children: subcategory.items.map(function (link, linkIndex) {
                      return /*#__PURE__*/_jsx(AccordionInnerItem, {
                        children: /*#__PURE__*/_jsx(AccordionInnerLink, {
                          href: link.path,
                          $color: "white",
                          $size: "medium",
                          children: /*#__PURE__*/_jsxs(Box, {
                            $styles: {
                              position: 'relative',
                              zIndex: 2
                            },
                            children: [link.title, link.description && /*#__PURE__*/_jsx(AccordionLinkDescription, {
                              children: link.description
                            })]
                          })
                        })
                      }, linkIndex);
                    })
                  }), subcategory.viewAllLink && /*#__PURE__*/_jsx(AccordionAdditionalLink, {
                    $variant: "regular",
                    $color: "white",
                    $size: "medium",
                    withArrow: true,
                    href: subcategory.viewAllLink.path,
                    children: subcategory.viewAllLink.title
                  })]
                }, subcategoryIndex);
              })
            })
          })]
        }, categoryIndex);
      })
    })
  });
};

export default AccordionMenu;